import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import CssBaseline from '@mui/material/CssBaseline'
import NamedThemeProvider from '@syte-tech/ui/theme/NamedThemeProvider'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <title>PV Pro</title>
    <link rel="icon" href="https://cdn.prod.website-files.com/629f9219b048c71b629825df/6324541da18e6bf7d75d4524_favicon.png" />
    <CssBaseline />
    <NamedThemeProvider theme="default">
      <App />
    </NamedThemeProvider>
  </>
)